<div fxLayout fxLayoutAlign="start center" class="dialog-header">
  <h3 fxFlex>Check-in activity</h3>
  <div class="close-btn clickable" mat-dialog-close>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.375 14.625L14.625 3.375"
        stroke="#D0CDD4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M3.375 3.375L14.625 14.625"
        stroke="#D0CDD4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </div>
</div>

<div class="dialog-body">
  <div *ngIf="!guests || guests.length < 1" class="guests-none">No check-in activity during this period.</div>

  <div *ngIf="guests?.length > 0">
    <div class="guests-header" fxLayout fxLayoutAlign="start center">
      <div fxFlex>Guest name</div>
      <div fxFlex>Check-in date</div>
    </div>

    <div *ngFor="let guest of guests" class="guest-entry" fxLayout fxLayoutAlign="start center">
      <strong fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <img
          fxFlex="20px 0 0"
          [src]="guest.picture"
          [alt]="guest.name"
          class="guest-img"
          onerror="this.src='/assets/images/profile-default.png'" />
        <span>{{ guest.name }}</span>
      </strong>
      <span fxFlex>{{ guest.check_in_date }}</span>
    </div>
  </div>
</div>
